(function () {
  if (customElements.get('er-discount-popup')) return;

  class ErDiscountPopup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.isDesignMode = this.dataset.designMode === 'true';
      this.closeButtons = Array.prototype.slice.call(this.querySelectorAll('[data-popup-close]'));
      this.copyButton = this.querySelector('[data-popup-copy]');
      this.previouslyFocused = null;
      this.onKeydown = this.handleKeydown.bind(this);
      this.onScroll = this.handleScroll.bind(this);
      this.onExit = this.handleExit.bind(this);
      this.closeButtons.forEach((button) => {
        if (button.classList.contains('er-discount-popup__overlay') && this.dataset.closeOverlay !== 'true') return;
        button.addEventListener('click', () => this.close());
      });
      if (this.copyButton) this.copyButton.addEventListener('click', () => this.copyCode());
      if (this.isDesignMode) {
        window.setTimeout(() => this.open(), 250);
        return;
      }
      if (this.dataset.enabled !== 'true' || this.isSuppressed()) return;
      this.schedule();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('mouseout', this.onExit);
      document.removeEventListener('keydown', this.onKeydown);
      window.clearTimeout(this.openTimer);
    }

    isSuppressed() {
      try {
        const until = Number(window.localStorage.getItem(this.dataset.storageKey));
        return until && until > Date.now();
      } catch (error) {
        return false;
      }
    }

    suppress() {
      if (this.isDesignMode) return;
      const days = Math.max(Number(this.dataset.frequency) || 1, 1);
      try { window.localStorage.setItem(this.dataset.storageKey, String(Date.now() + (days * 86400000))); } catch (error) {}
    }

    schedule() {
      if (this.dataset.trigger === 'scroll') {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.handleScroll();
      } else if (this.dataset.trigger === 'exit') {
        document.addEventListener('mouseout', this.onExit);
      } else {
        this.openTimer = window.setTimeout(() => this.open(), Math.max(Number(this.dataset.delay) || 1, 1) * 1000);
      }
    }

    handleScroll() {
      const available = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      if ((window.scrollY / available) * 100 < Number(this.dataset.scroll || 35)) return;
      window.removeEventListener('scroll', this.onScroll);
      this.open();
    }

    handleExit(event) {
      if (window.innerWidth < 900 || event.relatedTarget || event.clientY > 8) return;
      document.removeEventListener('mouseout', this.onExit);
      this.open();
    }

    open() {
      if (!this.hidden) return;
      this.previouslyFocused = document.activeElement;
      this.hidden = false;
      this.classList.add('is-opening');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      window.requestAnimationFrame(() => this.querySelector('.er-discount-popup__close')?.focus());
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      this.classList.remove('is-opening');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      this.suppress();
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') this.previouslyFocused.focus();
    }

    handleKeydown(event) {
      if (event.key === 'Escape') this.close();
      if (event.key !== 'Tab') return;
      const focusable = Array.prototype.slice.call(this.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])')).filter((node) => node.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }

    async copyCode() {
      const code = this.copyButton.dataset.code;
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      const instruction = this.copyButton.querySelector('small');
      if (instruction) instruction.textContent = this.copyButton.dataset.copiedText;
    }
  }

  customElements.define('er-discount-popup', ErDiscountPopup);

  document.addEventListener('shopify:section:select', function (event) {
    const popup = event.target.querySelector('er-discount-popup');
    if (popup) popup.open();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    const popup = event.target.querySelector('er-discount-popup');
    if (popup) popup.close();
  });
})();
